import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import pdf_icon from "app/assets/icons/pdf_icon.svg";
import UploadIcon from "app/assets/icons/UploadIcon";
import DeleteIcon from "app/assets/icons/DeleteIcon";

interface FileUploadCardProps {
  label: string;
  description: string;
  filePreview: string | null;
  file?: File | null;
  register: UseFormRegisterReturn;
  onFileChooseClick: () => void;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDelete: () => void;
  error?: string;
  fileInputRef: React.RefObject<HTMLInputElement>;
  acceptTypes?: string;
}

const FileUploadCard: React.FC<FileUploadCardProps> = ({
  label,
  description,
  filePreview,
  file,
  register,
  onFileChooseClick,
  onFileChange,
  onDelete,
  error,
  fileInputRef,
  acceptTypes = "image/jpeg,image/png,application/pdf",
}) => {
  const isPdf = file?.type === "application/pdf";

  return (
    <div className="w-full md:w-full xl:w-[49%]">
      {filePreview ? (
        <div className="bg-[#EAECF0] p-5 w-full text-center rounded-[20px] relative h-[250px] flex justify-center items-center">
          {isPdf ? (
            <div className="text-center w-[80%] overflow-hidden mx-auto">
              <img
                src={pdf_icon}
                alt="pdf_icon"
                className="rounded-[20px] m-auto"
              />
              <p className="font-Mulish text-[#000] font-normal text-base">
                {file?.name}
              </p>
            </div>
          ) : (
            <img
              src={filePreview}
              alt="Uploaded Preview"
              className="mx-auto h-[220px] rounded-[20px]"
              onError={(e) => (e.currentTarget.src = pdf_icon)}
            />
          )}
          <DeleteIcon
            onClick={onDelete}
            className="absolute cursor-pointer top-[10px] right-[10px]"
          />
        </div>
      ) : (
        <div className="bg-[#EAECF0] py-5 w-full relative text-center rounded-[20px] h-[250px]">
          <div className="text-center">
            <UploadIcon />
          </div>
          <h6 className="text-[14px] font-Mulish font-normal w-[90%] sm:w-[90%] mx-auto text-darkgrey mb-3 mt-4">
            {label}
          </h6>
          <p className="text-[12px] font-normal text-[#98A2B3] w-[90%] sm:w-[80%] mx-auto mb-5">
            {description}
          </p>
          <div className="m-auto">
            <input
              type="file"
              accept={acceptTypes}
              {...register}
              onChange={onFileChange}
              ref={fileInputRef}
              hidden
            />
            <button
              type="button"
              onClick={onFileChooseClick}
              className="border border-solid border-[#ccc] text-sm font-normal text-[#585C7B] rounded-full px-4 py-2"
            >
              Choose file
            </button>
          </div>
          {error && (
            <ErrorsMessage
              title={error}
              className="absolute top-[100%] left-0"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default FileUploadCard;
